import client from './client';

export interface InquiryListItem {
  id: string;
  maskedAuthor: string;
  content: string;
  isFaq: boolean;
  isPinned: boolean;
  adminAnswer: string | null;
  isMine: boolean;
  createdAt: string;
}

export interface InquiryDetail extends InquiryListItem {
  contactEmail: string | null;
  contactPhone: string | null;
}

export interface CreateInquiryPayload {
  content: string;
  contactEmail?: string;
  contactPhone?: string;
}

function unwrap<T>(raw: any): T {
  if (raw.success === false) throw new Error(raw.error || '요청 실패');
  return (raw.data ?? raw) as T;
}

export async function listInquiries(franchiseId: string): Promise<InquiryListItem[]> {
  const res = await client.get(`/api/franchise/${franchiseId}/inquiries`);
  return unwrap<InquiryListItem[]>(res.data);
}

export async function createInquiry(
  franchiseId: string,
  payload: CreateInquiryPayload,
): Promise<{ id: string }> {
  const res = await client.post(`/api/franchise/${franchiseId}/inquiries`, payload);
  return unwrap<{ id: string }>(res.data);
}

export async function getInquiry(
  franchiseId: string,
  id: string,
): Promise<InquiryDetail> {
  const res = await client.get(`/api/franchise/${franchiseId}/inquiries/${id}`);
  return unwrap<InquiryDetail>(res.data);
}
